module.exports = __webpack_public_path__ + "static/img/index1_4.2d8aca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jpg/index1_4.png
// module id = 5beF
// module chunks = 1